<template lang="pug">
  .cms-partial(v-if="html")
    component(:is="htmlComponent")
    component(is="style" v-if="css") {{css}}

</template>

<script>
  import vueCmsSvc from "@services/vueCmsSvc";

  export default {
    name: "CMSPartial",

    props: {
      mixinKey: {
        type: String,
      },
      initHtml: {
        type: String
      },
      initCss: {
        type: String
      }
    },

    data() {
      return {
        html: null,
        css: null,
      };
    },

    computed: {
      htmlComponent() {
        return {
          template: this.html,
        };
      },
    },

    methods: {
      update() {
        if (this.mixinKey) {
          vueCmsSvc.getPartial({ mixinKey: this.mixinKey }).then(res => {
            this.html = res.data.html;
            this.css = res.data.css;
          });
        }
      }
    },

    watch: {
      mixinKey: {
        immediate: true,
        handler() {
          this.update();
        }
      }
    },

    created() {
      if (this.initHtml && this.initCss) {
        this.html = this.initHtml;
        this.css = this.initCss;
      }
    }
  };
</script>

<style scoped lang="stylus">
</style>
